<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'MANAGEMENT_TOOL.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'MANAGEMENT_TOOL.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'HOME.MANAGEMENT_TOOL_TEXT' | translate }}</p>
      <div class="ph-hero__actions ph-hero__actions--centered">
        <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'MANAGEMENT_TOOL.CTA' | translate }}
        </a>
        <a href="#features" class="ph-btn ph-btn--outline ph-btn--lg">{{ 'MANAGEMENT_TOOL.FEATURES_TITLE' | translate }}</a>
      </div>
    </div>
  </section>

  <section id="features" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'MANAGEMENT_TOOL.FEATURES_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'MANAGEMENT_TOOL.FEATURES_LEAD' | translate }}</p>
      </div>

      <div class="ph-benefits-grid">
        <article *ngFor="let item of features" class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni" [ngClass]="item.icon"></i></div>
          <h3 class="ph-benefit-card__title">{{ item.titleKey | translate }}</h3>
          <p class="ph-benefit-card__text">{{ item.textKey | translate }}</p>
        </article>
      </div>

      <div class="ph-kpi-grid">
        <article *ngFor="let kpi of kpiSamples" class="ph-kpi-card">
          <p class="ph-kpi-card__label">{{ kpi.labelKey | translate }}</p>
          <p class="ph-kpi-card__value">{{ kpi.value }}</p>
        </article>
      </div>
      <p class="ph-kpi-note">{{ 'MANAGEMENT_TOOL.KPI_NOTE' | translate }}</p>
    </div>
  </section>

  <section id="cta" class="ph-section">
    <div class="ph-container ph-container--narrow">
      <div class="ph-page-cta">
        <h2 class="ph-page-cta__title">{{ 'HOME.PERFORMANCE_DASHBOARD_TITLE' | translate }}</h2>
        <p class="ph-page-cta__text">{{ 'HOME.PERFORMANCE_DASHBOARD_TEXT' | translate }}</p>
        <div class="ph-page-cta__actions">
          <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'HOME.ACCESS_DASHBOARD' | translate }}
          </a>
          <a routerLink="/pricing" class="ph-btn ph-btn--outline ph-btn--lg">{{ 'PRICING.REQUEST_OFFER_BUTTON' | translate }}</a>
        </div>
      </div>
    </div>
  </section>

  <section id="related" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'MANAGEMENT_TOOL.RELATED_TITLE' | translate }}</h2>
      </div>
      <div class="ph-tools__grid">
        <a *ngFor="let link of relatedLinks" [routerLink]="link.route" class="ph-tool-card">
          <div class="ph-tool-card__icon"><i class="lni" [ngClass]="link.icon"></i></div>
          <h3 class="ph-tool-card__title">{{ link.titleKey | translate }}</h3>
          <p class="ph-tool-card__text">{{ link.textKey | translate }}</p>
          <span class="ph-tool-card__cta">
            {{ 'HOME.LEARN_MORE' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>
</div>
